import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "shared/lib/hooks/hooks";
import CustomNavigate from "shared/lib/CustomNavigate/CustomNavigate";
import Header from "widget/Header/Header";
import AdminHeader from "widget/AdminHeader/AdminHeader";
import { USER_LOGIN_PATH } from "pages/paths";
import { HubConnection } from "@microsoft/signalr";
import { createSignalRConnection } from "shared/lib/signalr";
import {
  setAllUsersNotificationsCount,
  setDisabledUsersNotificationsCount,
  setUnreadNotificationsCount,
} from "entities/admin/model/slice";

const Layout: React.FC = (): JSX.Element => {
  const userRole = useAppSelector((state) => state.users.userRole);
  const isAuth = useAppSelector((state) => state.users.isAuth);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const [notificationConnection, setNotificationConnection] =
    useState<HubConnection | null>(null);

  useEffect(() => {
    let notificationClient: ReturnType<typeof createSignalRConnection> | null = null;

    if (userRole === 'Owner') {
      notificationClient = createSignalRConnection("/hubs/document-notification");
      setNotificationConnection(notificationClient);
    }

    return () => {
      if (notificationClient) {
        notificationClient.stop();
      }
    };
  }, [isAuth, userRole]);

  useEffect(() => {
    if (!notificationConnection) return;

    notificationConnection.onreconnected((connectionId) => {
      console.log(`Notification Hub переподключён, connectionId: ${connectionId}`);
    });

    notificationConnection.onclose((error) => {
      console.log(`Notification Hub закрыт: ${error ? error.message : "нет ошибки"}`);
    });

    notificationConnection.onreconnecting((error) => {
      console.log("Notification Hub пытается переподключиться", error);
    });

    notificationConnection.on("ReceiveNotification", (message) => {
      console.log("ReceiveNotification:", message);
    });
    notificationConnection.on("UpdateUnreadCount", (message) => {
      dispatch(setUnreadNotificationsCount(parseInt(message, 10)));
    });
    notificationConnection.on("UpdateAllCount", (message) => {
      dispatch(setAllUsersNotificationsCount(parseInt(message, 10)));
    });
    notificationConnection.on("UpdateDisableCount", (message) => {
      dispatch(setDisabledUsersNotificationsCount(parseInt(message, 10)));
    });
  }, [notificationConnection, dispatch]);

  useEffect(() => {
    if (
      !localStorage.getItem("AccessToken") &&
      location.pathname.includes("/personal_cabinet")
    ) {
      navigate(USER_LOGIN_PATH, {
        state: { from: location.pathname },
      });
    }
  }, []);

  return (
    <>
      <CustomNavigate />
      {userRole === "Admin" ||
        userRole === "Owner" ||
        userRole === "Volunteer" ? (
        <AdminHeader />
      ) : (
        <Header />
      )}
      <Outlet />
    </>
  );
};

export default Layout;
